<template>

    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="30%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">Confirm {{ entityType }} deletion</span>

                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text class="modal-height" style="text-align: left">

                        <span class="body-2">Deleting a {{ entityType }} will permanently remove it from the database.</span>

                    </v-card-text>

                    <v-alert :value="error" type="error" transition="scale-transition">
                        {{ errorMessage }}
                    </v-alert>


                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="confirm_setting_deletion" class="text-none" color="red" small dark @click="onDelete">
                            Yes, delete
                            {{entityType}}
                        </v-btn>
                        <v-btn id="cancel_setting_deletion" class="text-none" small @click="close">No, keep {{
                            entityType }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>


</template>

<script>

    import {EventBus} from "../../../eventbus";
    import errormessagemanager from "../../../managers/errormessagemanager";
    import systemsettinginterface from "../../../interfaces/systemsettinginterface";
    import settinginterface from "../../../interfaces/settinginterface";

    export default {
        name: 'ConfirmSettingDeletionModal',

        data: () => ({
            error: false,
            errorMessage: null,
        }),

        props: {
            value: Boolean,

            isSystemSetting: Boolean,

            setting: {
                settingId: Number,
                key: String,
                value: String,
                description: String
            },

            systemSetting: {
                systemSettingId: Number,
                key: String,
                value: String,
                description: String
            }
        },

        computed: {
            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            },

            entityType() {
                if (this.isSystemSetting) {
                    return "system setting";
                } else {
                    return "setting";
                }
            }
        },

        methods: {
            async onDelete() {
                if (this.isSystemSetting) {
                    await this.onDeleteSystemSetting(this.systemSetting);
                } else {
                    await this.onDeleteSetting(this.setting);
                }
            },

            async onDeleteSystemSetting(systemSetting) {
                let response = null;

                await systemsettinginterface.deleteSystemSetting(systemSetting, requestResponse => {
                    response = requestResponse;
                });

                if (response != null && !response.error) {
                    await EventBus.$emit('systemSettingDeletionConfirmed');

                    this.onShow = false;
                    this.systemSetting = null;
                } else {
                    errormessagemanager.getDeletionErrorMessage(response.status, message => {
                        this.errorMessage = message;
                    });
                    this.error = response.error;
                }
            },

            async onDeleteSetting(setting) {
                this.clearAlert();

                let response = null;

                await settinginterface.deleteSetting(setting, requestResponse => {
                    response = requestResponse;
                });

                if (response != null && !response.error) {
                    await EventBus.$emit('settingDeletionConfirmed');

                    this.onShow = false;
                    this.setting = null;
                } else {
                    errormessagemanager.getDeletionErrorMessage(response.status, message => {
                        this.errorMessage = message;
                    });
                    this.error = response.error;
                }
            },


            async close() {
                await EventBus.$emit("settingDeletionClosed");
                this.onShow = false;
                this.right = null;

                this.clearAlert();
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = "";
            }
        }
    }
</script>

<style>
    .modal-height {
        min-height: 100px;
    }
</style>


// WEBPACK FOOTER //
// src/components/settings/modals/ConfirmSettingDeletionModal.vue